import React, { Fragment, useEffect } from 'react';

import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Container from '../../components/Container';
import accessmap from '../../photos/accessmap.jpg';

const AboutWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    ${props => props.theme.breakpoints.down('xs')} {
        flex-direction: column;
    }
    margin-top: 16px;
`;

const AccessDiv = styled.div`
    align-self: center;
`;

const MapImage = styled.img`
    width: 100%;
`;

const Access = () => {

    useEffect(() => window.scrollTo(0,0));

    return (
        <Fragment>
            <Header />
            <Container>
                <Typography variant="h6">アクセス</Typography>
                <AboutWrapper>
                    <AccessDiv>
                        <MapImage src={accessmap} />
                    </AccessDiv>
                    <AccessDiv>
                        <Typography variant="body1">
                            <Typography component="div">住所 ｜〒425-0015 静岡県焼津市石脇上59-3</Typography>
                            <Typography component="div">TEL/FAX ｜054-628-5160</Typography>
                            <Typography component="div">駐車場が3台ございます。</Typography>
                            <Typography component="div">駐停車など近隣の皆様にご迷惑のかからぬよう、ご協力の程、宜しくお願いいたします。</Typography>
                        </Typography>
                        <Typography style={{marginTop: "16px"}} variant="body1">
                            <Typography component="div">焼津駅から車で8分</Typography>
                            <Typography component="div">焼津駅からバスで10分（東益津小学校前停車）徒歩1分</Typography>
                        </Typography>
                    </AccessDiv>
                </AboutWrapper>
            </Container>
            <Footer />
        </Fragment>
    )
}

export default Access;